module.exports = __webpack_public_path__ + "media/images/infinite_shop-fea7a1363c2d39129d369aed2ae328f9.png";